export const nav = 1;

export const getStates = (menu = "app-releases", other) => {
  const base = menu || "app-releases";
  return {
    [base]: {
      nav,
      landing: true,
      menu, // <ui-view/>
      breadcrumbs: true,
      pageHeader: true,
      icon: "tablet",
      title: "App Releases",
      url: "/" + base, // + "?uploaded&mode",
      params: {},
      // rerouteTo: `${base}.list`,
      // authorize: s => s.hasPermission("ViewCatalogs"),
      templateProvider: ($stateParams) => `<app-releases-container  />`,
      ...other,
    },
  };
};

export default getStates();
